import { Page } from "../../helpers/response";
import { Component, Input, EventEmitter, Output } from "@angular/core";

@Component({
  selector: "pagination-ar",
  templateUrl: "./pagination-ar.component.html",
  styles: [
    `
    .select-pagination {
        height: 35px;
        width: 80px;
        padding: 0.5rem 0.75rem;
    }`
  ]
})
export class PaginationARComponent {
  @Input() page = new Page();
  @Input() rowsPerPage: number[] = [];
  @Input() maxSize = 4;
  @Input() boundaryLinks = true;
  @Input() previousText = "&lsaquo;";
  @Input() nextText = "&rsaquo;";
  @Input() firstText = "&laquo;";
  @Input() lastText = "&raquo;";
  @Input() showTotalRows = true;
  @Input() showPageSize = true;

  @Output() onPaginate = new EventEmitter<Page>();

  pageChanged(event?: any) {
    if (event) {
      this.page.Number = event.page;
      this.page.Size = event.itemsPerPage;
    }

    this.onPaginate.emit(this.page);
  }

  sizeChange(itemsPerPage: any) {
    this.pageChanged({
      page: 1,
      itemsPerPage: itemsPerPage
    });
  }
}
